
























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesAnalyse extends Vue {

  // 売上集計用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public year: number = null;
  public period: number = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public itemCategory: number = null;
  public summaryCategory1: number = null;
  public summaryCategory2: number = null;
  // public includeProspect: boolean = false;
  public tenantSetting: Common.TenantSettings = null;
  public onExcelExport :boolean = false;
  public searchDeliveryDate: boolean = false;
  public includeProspectType: Common.IncludeProspectTypes = Common.IncludeProspectTypes.None;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.SalesAnalyseReportTemplateQuery = new Common.SalesAnalyseReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.tenantSetting = this.$api.tenantSettings; 
    var today:Date = new Date().getCalendarDate();
    if (this.tenantSetting.startMonth <= today.getMonth()+1) this.year = today.getFullYear();
    else this.year = today.getFullYear() -1; 
    
    var firstPeriod: Date = new Date(this.year, this.tenantSetting.startMonth + 5, 0).getCalendarDate();
    if (firstPeriod >= today) this.period = 0;
    else this.period = 1;

    (this.$refs.SalesAnalyseDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesAnalyseReportQuery = new Common.SalesAnalyseReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.year = this.year;
    query.month = this.tenantSetting.startMonth;
    query.period = this.period;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.itemCategory = this.itemCategory;
    if (this.summaryCategory1 == null) query.summaryCategory1 = 0;
    else query.summaryCategory1 = this.summaryCategory1;
    if (this.summaryCategory2 == null) query.summaryCategory2 = 0;
    else query.summaryCategory2 = this.summaryCategory2;
    // query.includeProspect = this.includeProspect;
    query.onExcelExport = this.onExcelExport;
    query.includeProspectType = this.includeProspectType;
    query.searchDeliveryDate = this.searchDeliveryDate;
    this.$api.download(query);
  }
}
